<template>
  <div style="margin-top: 50px; margin-left: 40px; margin-right: 40px;">


    <!-- Price tiers.
         Western buyers see $2.99 only. Showing them the Rs 99 option would let any
         of them downgrade to a ~$1.15 payment, and the app should read as a US
         product to a US buyer.

         Everyone else sees both. An English-locale visitor in Australia, Singapore
         or Nigeria has no reason to hold rupees but every reason to pay in dollars,
         and collapsing them onto the cheaper INR tier would quietly charge them
         well under the Western price for no reason tied to where they are. The
         Rs 99 option is labelled for India specifically rather than "everywhere",
         since that is who it is actually priced for.
    -->
    <div class="pmt-tiers" :class="{ single: !showBothTiers }">
      <button type="button"
              class="pmt-tier"
              :class="{ active: priceKey === 'western' }"
              @click="setPriceTier('western')">
        <span class="pmt-tier-amount">$2.99</span>
        <span class="pmt-tier-note">US &middot; Canada &middot; Europe</span>
      </button>
      <button v-if="showBothTiers"
              type="button"
              class="pmt-tier"
              :class="{ active: priceKey === 'intl' }"
              @click="setPriceTier('intl')">
        <span class="pmt-tier-amount">&#8377;99</span>
        <span class="pmt-tier-note">India &middot; pay by UPI</span>
      </button>
    </div>

    <div id="payment-element">
    </div>
    <div id="button-element">
      <button type="submit"  @click="chargePayment" class="pmtbutton">Pay {{ priceLabel }}</button>
    </div>
  </div>

</template>

<script>
// import axios from 'axios';
import axios from '../axiosConfig'
import { toast } from 'bulma-toast'


// Regions kept at the original $2.99. Everything outside this set gets the
// Rs 99 tier, which in practice means India. Module-level rather than in
// data(), because it is a constant -- putting it in methods would make it an
// instance property that Vue does not treat as reactive state.
const WESTERN_REGIONS = [
      'US', 'CA',
      // Europe, as a single price tier. Buyers here see $2.99 converted into their
      // own currency and absorb the FX markup, same as before this change.
      'GB', 'IE', 'FR', 'DE', 'IT', 'ES', 'PT', 'NL', 'BE', 'AT', 'CH',
      'DK', 'SE', 'NO', 'FI', 'IS', 'PL', 'CZ', 'SK', 'HU', 'RO', 'BG',
      'GR', 'HR', 'SI', 'EE', 'LV', 'LT', 'LU', 'MT', 'CY', 'RS', 'UA'
    ];

export default {
  name: 'Payment',
  data() {
    return {
      wbid: '',
      stripe: '',
      elementsData: '',
      pubkey: '',
      client_secret: '',
      cardNumber: '',
      expDate: '',
      cvc: '',
      amount: '',
      // Price tier. 'western' is $2.99 (US, Canada, Europe); 'intl' is Rs 99 for
      // everywhere else, which in practice means India. Chosen from the buyer's own
      // browser locale rather than geo-IP: geo-IP misfires on VPNs, carrier NAT and
      // roaming, and penalises real customers who are abroad.
      priceKey: 'western',
      priceLabel: '$2.99',
      showBothTiers: true
    }
  },
mounted() {
    this.wbid = this.$route.query.wishboard_id;
    // Decide the tier before creating the first PaymentIntent, so the intent and
    // the rendered price label can never disagree.
    const tier = this.detectPriceTier();
    this.priceKey = tier.key;
    this.priceLabel = tier.label;
    this.showBothTiers = tier.showBoth;
    this.generatePaymentIntent();
    this.showSubmit();
  },
  methods: {
      showSubmit(){
          
      },
      getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
    },
    chargePayment(ev){
          let elements = this.elementsData; 
          const pmt_response = this.stripe.confirmPayment({
            elements,
            confirmParams: {
              // Derived from the current origin rather than hardcoded. A hardcoded
              // production URL meant a successful payment on localhost bounced to
              // the live site, taking the test off the board being paid for and
              // making local results meaningless.
              return_url: window.location.origin + '/wishboard?wishboard_id=' + this.wbid,
              },
            // redirect: 'if_required'
          })
          .then(function(result){
            if (result.error) {
              // Handle error and specify error message
              console.error(result.error.message); // Log the error message
              toast({
                      message: 'Payment Failed: ' + result.error.message,
                      type: 'is-danger',
                      dismissible: true,
                      pauseOnHover: true, 
                      duration: 5000,
                      position: 'bottom-center'
                })
            } else {
              // Payment confirmation was successful, handle success case
              console.log('Payment successful!', result.paymentIntent);
                toast({
                      message: 'Payment Succeeded: ' + result.paymentIntent,
                      type: 'is-success',
                      dismissible: true,
                      pauseOnHover: true, 
                      duration: 3000,
                      position: 'bottom-center'
                })
            }

          });

    },

    // Regions kept at the original $2.99. Anything outside this set gets Rs 99.
    // Matched on language-region subtags only, so 'en' alone (no region) falls
    // through to the international price rather than guessing 'en-US'.
    detectPriceTier() {
      const regions = (navigator.languages && navigator.languages.length)
        ? navigator.languages
        : [navigator.language || ''];
      for (const tag of regions) {
        const region = (tag.split('-')[1] || '').toUpperCase();
        if (!region) continue;
        if (WESTERN_REGIONS.indexOf(region) !== -1) {
          // Western: USD only, and pre-selected. Offering the cheaper tier here
          // would just hand every US buyer a discount button.
          return { key: 'western', label: '$2.99', showBoth: false };
        }
        // Elsewhere: default to USD, but keep the INR option visible. An
        // English-locale visitor in Australia or Singapore is far more likely to
        // want dollars than rupees, so defaulting them onto INR would quietly
        // charge them well under the Western price.
        return { key: 'western', label: '$2.99', showBoth: true };
      }
      // No region subtag at all. Offer both and default to dollars: guessing INR
      // here would mean a misdetected Western buyer gets a foreign-currency price.
      return { key: 'western', label: '$2.99', showBoth: true };
    },

    // Switch tier and rebuild the PaymentIntent. The Element is bound to one
    // client's secret, so changing price means re-creating the intent.
    setPriceTier(key) {
      if (key === this.priceKey) return;
      // The INR button is not rendered for Western buyers. Repeat the check here
      // so the restriction is not merely presentational -- otherwise a Western
      // visitor could call setPriceTier('intl') from the console and downgrade.
      // This is presentation, not security: the backend still accepts either key.
      if (key === 'intl' && !this.showBothTiers) return;
      const tiers = { western: '$2.99', intl: '₹99' };
      this.priceKey = key;
      this.priceLabel = tiers[key];
      this.client_secret = '';
      this.generatePaymentIntent();
      toast({
        message: 'Price set to ' + this.priceLabel,
        type: 'is-success',
        position: 'bottom-center',
        duration: 2000,
        dismissible: true,
      });
    },

    generatePaymentIntent(ev) {        

            let link = "/mywishboard/api/payment/"             
            let config_link = "/mywishboard/api/config/" 

            // price_key only -- never amount or currency. The backend looks the real
            // figures up in PRICE_TIERS and rejects anything it does not recognise,
            // so the charged amount cannot be chosen by the caller.
            var data = {
                "board_id": this.wbid,
                "price_key": this.priceKey,
                "description": "My First Test Charge (created for API docs at https://www.stripe.com/docs/api)",                
                "metadata[card_number]":this.cardNumber
            };

            axios
                // No Authorization header. Anyone may pay to unlock a board, so the
                // endpoint is unauthenticated -- sending a bearer built from a
                // possibly-empty store token only obscured that.
                .post(link, data, {
                    headers:{ 'Content-Type': 'application/json', 'X-requested-with': 'XMLHttpRequest', 'X-CSRFToken': this.getCookie('csrftoken')}
                })
                .then((response) => {                    
                    this.client_secret = response.data.clientSecret;
                    // Publishable key, which is public by design.
                    axios.get(config_link, {
                      headers:{ 'Content-Type': 'application/json', 'X-requested-with': 'XMLHttpRequest', 'X-CSRFToken': this.getCookie('csrftoken')}
                    })
                      .then(response => { this.pubkey = response.data.pubkey; })                                                         
                      .then(response => {                            
                              this.stripe = Stripe(this.pubkey);        
                              console.log(this.pubkey);
                              console.log(this.client_secret);
                              let elements = this.stripe.elements({
                                clientSecret: this.client_secret,
                              });
                              var paymentElement = elements.create('payment');
                              this.elementsData = elements;
                              paymentElement.mount('#payment-element');
                        }
                      )
                      .catch(error => {console.error('Error', error.message);})
                })
                .catch((error) => {
                    console.error(error);
                });
 
            localStorage.setItem("showme","true")
            console.log("showme is true")

        }
    
    }
}

</script>

<style scoped>
/* Price tier selector. Matched to .pmtbutton's existing treatment (purple
   #666EE8, 40px tall, 4px radius) so the tier choice and the Pay button read as
   one control rather than two competing ones. */
.pmt-tiers {
  display: flex;
  gap: 10px;
  margin: 18px 0 4px;
  flex-wrap: wrap;
}
.pmt-tier {
  flex: 1 1 180px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #dcdce6;
  border-radius: 6px;
  cursor: pointer;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  text-align: left;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}
.pmt-tiers.single .pmt-tier {
  flex: 1 1 auto;
}
.pmt-tier:hover {
  border-color: #b9b9ee;
}
.pmt-tier.active {
  border-color: #666EE8;
  background: #f5f5ff;
  box-shadow: 0 0 0 1px #666EE8 inset;
}
.pmt-tier-amount {
  font-size: 1.05rem;
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1.2;
}
.pmt-tier-note {
  font-size: 0.72rem;
  color: #888;
  line-height: 1.35;
}
</style>
